/**
 * The two device settings the frame can change. They are host routes, not
 * server actions: a server action runs in the app that renders the page, and a
 * module running as its own app could not reach the host's. The paths are
 * absolute, so the browser sends them to the host from either app.
 */
export const FRAME_SETTINGS_ROUTES = {
  theme: '/api/settings/theme',
  locale: '/api/settings/locale'
} as const

/** Posts one setting to the host; true when it was taken. */
export async function postFrameSetting(route: string, value: string): Promise<boolean> {
  const response = await fetch(route, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ value }),
    credentials: 'same-origin'
  })
  return response.ok
}
